/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BaseDesignRestService,
  ContactRestService,
  JobRestService,
  PriceBookRestService,
  PriceBookUsage,
  SystemRoleBit,
  systemRolesBitSet,
  UserRestService,
} from '@gh/builder-shared-data';
import { AutocompleteItem } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  JobCustomer,
  JobQuickCreateResponse,
  JobQuickDetails,
  jobQuickDetailsToCreateRequestDto,
  JobSalesPerson,
} from './job.model';

@Injectable()
export class JobQuickDetailsBusinessService {
  constructor(private jobRest: JobRestService,
              private baseDesignRest: BaseDesignRestService,
              private contactRest: ContactRestService,
              private userRest: UserRestService,
              private priceBookRest: PriceBookRestService) {

  }

  create(details: JobQuickDetails): Observable<JobQuickCreateResponse> {
    return this.jobRest.createQuick(jobQuickDetailsToCreateRequestDto(details));
  }

  findCustomersByName(query: FilteredDataQuery<string>): Observable<JobCustomer[]> {
    return this.contactRest.findAllCustomersAsDataSource({
      name: query.filter,
      showLeads: true,
    }).select(query).pipe(map$(getSlicedData));
  }

  findSalesPersonsByName(query: FilteredDataQuery<string>): Observable<JobSalesPerson[]> {
    return this.userRest.findAllAsDataSource({
      name: query.filter,
      showInactive: false,
      autocomplete: true,
      systemRoles: systemRolesBitSet(SystemRoleBit.SalesPerson),
    }).select(query).pipe(map$(getSlicedData));
  }

  findPriceBooksByName(query: FilteredDataQuery<string>): Observable<AutocompleteItem[]> {
    return this.priceBookRest.findAllAsAutocompleteDataSource({
      searchString: query.filter,
      usage: [PriceBookUsage.Normal],
    }).select(query).pipe(map$(getSlicedData));
  }

  findAllBaseDesignsByName(query: FilteredDataQuery<string>): Observable<AutocompleteItem[]> {
    return this.baseDesignRest.findAllAsDataSource({
      searchString: query.filter,
      showDeleted: false,
    }).select(query).pipe(map$(getSlicedData));
  }
}
